import image_logo from "../../assets/images/logo.svg";
import {
    PROVIDER,
    OPERATOR,
    controllerLine,
    providerRoleSentence,
} from "../../config/legalEntities";

function TermsAndConditionsRider() {
    const appName = process.env.REACT_APP_NAME || "TruHail";
    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 py-10">
            <div className="mb-8 h-[80px] overflow-hidden rounded-2xl">
                <img
                    src={image_logo}
                    alt={`Logo ${appName}`}
                    height={80}
                    className="h-full w-full object-cover"
                />
            </div>

            <div className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-md">
                <h1 className="mb-4 text-2xl font-bold">
                    Termos e Condições de Uso — Passageiros
                </h1>
                <p className="mb-6 text-sm text-gray-500">
                    Última atualização: 26 de fevereiro de 2026
                </p>
                <p className="mb-8 text-lg">
                    Estes Termos e Condições (&quot;Termos&quot;) regulam o uso do
                    aplicativo {appName} por você, na qualidade de Passageiro. Ao
                    cadastrar-se ou utilizar o aplicativo, você declara ter lido,
                    compreendido e concordado integralmente com estes Termos.
                </p>

                <div className="space-y-8">
                    {/* 1. Definições */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">1. Definições</h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                <strong>&quot;Provedora da Plataforma&quot;</strong>:{" "}
                                {PROVIDER.name} (CNPJ {PROVIDER.cnpj}), responsável pelo
                                desenvolvimento e manutenção da infraestrutura tecnológica do
                                aplicativo. {providerRoleSentence}
                            </li>
                            <li>
                                <strong>&quot;Operadora&quot; (Controladora dos dados)</strong>:{" "}
                                {controllerLine} — empresa ou pessoa física que licencia e opera
                                o aplicativo sob marca própria (whitelabel), sendo responsável
                                pela gestão do serviço junto a Motoristas e Passageiros e pela
                                determinação das finalidades do tratamento dos dados pessoais.
                            </li>
                            <li>
                                <strong>&quot;Plataforma&quot;</strong>: o aplicativo móvel{" "}
                                {appName} e todos os serviços e sistemas associados.
                            </li>
                            <li>
                                <strong>&quot;Passageiro&quot; ou &quot;Usuário&quot;</strong>:
                                pessoa física cadastrada no aplicativo para solicitar corridas.
                            </li>
                            <li>
                                <strong>&quot;Motorista&quot;</strong>: pessoa física cadastrada
                                como prestadora de serviço de transporte na Plataforma.
                            </li>
                            <li>
                                <strong>&quot;Serviço&quot;</strong>: intermediação tecnológica
                                entre Passageiros e Motoristas para a realização de corridas.
                            </li>
                        </ul>
                    </div>

                    {/* 2. Aceite */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">2. Aceite dos Termos</h2>
                        <p>
                            Ao instalar, acessar ou utilizar a Plataforma, você concorda com
                            estes Termos e com a nossa{" "}
                            <a
                                href="/privacy-policy-rider"
                                className="text-blue-600 underline"
                            >
                                Política de Privacidade
                            </a>
                            . Caso não concorde, você deve cessar imediatamente o uso da
                            Plataforma.
                        </p>
                    </div>

                    {/* 3. Elegibilidade */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            3. Elegibilidade e Cadastro
                        </h2>
                        <p className="mb-2">Para utilizar a Plataforma como Passageiro, você deve:</p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>Possuir idade mínima de 18 (dezoito) anos</li>
                            <li>
                                Fornecer dados verdadeiros: nome completo, e-mail válido e
                                número de telefone ativo
                            </li>
                            <li>Realizar verificação do número de telefone via SMS/OTP</li>
                            <li>Manter seus dados cadastrais atualizados</li>
                        </ul>
                    </div>

                    {/* 4. Descrição do Serviço */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            4. Descrição do Serviço
                        </h2>
                        <p className="mb-2">
                            A Plataforma oferece intermediação tecnológica entre Passageiros e
                            Motoristas. Os serviços incluem:
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>Solicitação de corridas com definição de origem e destino</li>
                            <li>
                                Recebimento e avaliação de propostas de valor de motoristas
                            </li>
                            <li>Pagamento via meios disponíveis (dinheiro, cartão, online)</li>
                            <li>Acompanhamento em tempo real da corrida</li>
                            <li>Avaliação e classificação do motorista após cada corrida</li>
                            <li>Agendamento de corridas futuras (quando disponível)</li>
                        </ul>
                        <p className="mt-2 text-sm text-gray-600">
                            <strong>Nota:</strong> A Plataforma é uma intermediadora
                            tecnológica e não uma empresa de transporte. A responsabilidade
                            pela prestação do serviço de transporte é do Motorista.
                        </p>
                    </div>

                    {/* 5. Obrigações do Passageiro */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            5. Obrigações do Passageiro
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>Informar o destino preciso antes de confirmar a corrida</li>
                            <li>
                                Garantir que possui meio de pagamento válido e suficiente para
                                cobrir o valor da corrida
                            </li>
                            <li>
                                Tratar motoristas com respeito e zelar pela integridade do
                                veículo
                            </li>
                            <li>Não solicitar corridas com fins fraudulentos ou ilegais</li>
                            <li>
                                Estar no local de embarque no horário combinado ou dentro do
                                tempo de espera
                            </li>
                            <li>
                                Não transportar substâncias ilícitas, armas ou materiais
                                perigosos
                            </li>
                            <li>
                                Comunicar imediatamente qualquer incidente de segurança à
                                Plataforma
                            </li>
                        </ul>
                    </div>

                    {/* 6. Pagamentos */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">6. Pagamentos</h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                Os valores das corridas são calculados com base em distância,
                                duração, categoria do veículo e demanda
                            </li>
                            <li>
                                O pagamento pode ser feito em espécie ao motorista ou via
                                pagamento online, conforme modalidades disponíveis
                            </li>
                            <li>
                                Pagamentos online são processados por provedores de pagamento
                                terceirizados conforme listados em nossa Política de Privacidade
                            </li>
                            <li>
                                Taxas de serviço podem ser aplicadas e serão sempre informadas
                                antes da confirmação da corrida
                            </li>
                            <li>
                                Estornos e reembolsos estão sujeitos às políticas da Plataforma
                                e do provedor de pagamento
                            </li>
                        </ul>
                    </div>

                    {/* 7. Cancelamentos e Disputas */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            7. Cancelamentos e Disputas
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                Cancelamentos dentro do período de cancelamento gratuito não
                                geram cobranças
                            </li>
                            <li>
                                Cancelamentos após o período gratuito podem acarretar taxa de
                                cancelamento
                            </li>
                            <li>
                                Disputas devem ser reportadas pela Plataforma e serão analisadas
                                pela Operadora
                            </li>
                            <li>
                                A Plataforma não se responsabiliza por disputas de natureza
                                exclusivamente pessoal entre Passageiro e Motorista
                            </li>
                        </ul>
                    </div>

                    {/* 8. Propriedade Intelectual */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            8. Propriedade Intelectual
                        </h2>
                        <p>
                            Todos os direitos sobre o software, marcas, logotipos, interfaces,
                            algoritmos e conteúdos da Plataforma pertencem à Provedora da
                            Plataforma ({PROVIDER.name}) e/ou à Operadora ({OPERATOR.name}),
                            conforme aplicável. É vedada a
                            reprodução, modificação, engenharia reversa, distribuição ou uso
                            comercial não autorizado de qualquer parte da Plataforma.
                        </p>
                    </div>

                    {/* 9. Limitação de Responsabilidade */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            9. Limitação de Responsabilidade
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                A <strong>Provedora da Plataforma</strong> fornece a
                                infraestrutura tecnológica &quot;como está&quot; (as is) e não se
                                responsabiliza por danos diretos, indiretos, incidentais ou
                                consequenciais decorrentes do uso do Serviço de transporte
                            </li>
                            <li>
                                A <strong>Operadora</strong> é responsável pela gestão e suporte
                                ao Passageiro dentro do escopo do Serviço oferecido
                            </li>
                            <li>
                                A Plataforma não garante disponibilidade ininterrupta do
                                Serviço, podendo ocorrer interrupções para manutenção ou por
                                motivos de força maior
                            </li>
                            <li>
                                A responsabilidade total da Provedora da Plataforma e da
                                Operadora é limitada ao valor pago pelo Passageiro nos últimos
                                12 meses
                            </li>
                        </ul>
                    </div>

                    {/* 10. Indenização */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">10. Indenização</h2>
                        <p>
                            O Passageiro concorda em indenizar e isentar a Provedora da
                            Plataforma, a Operadora, seus diretores, funcionários e parceiros
                            de quaisquer reclamações, danos, perdas ou despesas (incluindo
                            honorários advocatícios) decorrentes do uso indevido da Plataforma
                            ou violação destes Termos.
                        </p>
                    </div>

                    {/* 11. Suspensão e Encerramento */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            11. Suspensão e Encerramento de Conta
                        </h2>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                A Plataforma reserva-se o direito de suspender ou encerrar
                                contas por comportamento inadequado, fraudulento ou que viole
                                estes Termos
                            </li>
                            <li>
                                O Passageiro pode solicitar o encerramento de sua conta a
                                qualquer momento, sujeito à conclusão de corridas pendentes e
                                liquidação de valores devidos
                            </li>
                            <li>
                                Dados pessoais serão tratados conforme a Política de
                                Privacidade, mesmo após o encerramento
                            </li>
                        </ul>
                    </div>

                    {/* 12. Legislação e Foro */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            12. Legislação Aplicável e Foro
                        </h2>
                        <p>
                            Estes Termos são regidos pelas leis de proteção de dados e
                            legislação consumerista aplicáveis na jurisdição da Operadora.
                            Eventuais litígios serão submetidos ao foro competente da comarca
                            do domicílio do Passageiro, conforme legislação aplicável.
                        </p>
                    </div>

                    {/* 13. Alterações */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            13. Alterações dos Termos
                        </h2>
                        <p>
                            A Provedora da Plataforma e/ou a Operadora reservam-se o direito
                            de alterar estes Termos a qualquer momento. Alterações relevantes
                            serão comunicadas pelo aplicativo, e-mail ou outros canais
                            disponíveis, com antecedência razoável. O uso continuado da
                            Plataforma após a notificação constitui aceite das alterações.
                        </p>
                    </div>

                    {/* 14. Provedores e Subprocessadores */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">
                            14. Provedores e Subprocessadores
                        </h2>
                        <p className="mb-2">
                            Para operar o Serviço, a Plataforma compartilha apenas os dados
                            estritamente necessários com provedores terceirizados
                            (subprocessadores), que atuam em nosso nome para funções como
                            processamento de pagamentos, notificações, mapas, infraestrutura e
                            distribuição do aplicativo. Não comercializamos seus dados pessoais.
                            Cada provedor está sujeito à sua própria política, disponível abaixo:
                        </p>
                        <ul className="list-inside list-disc space-y-1">
                            <li>
                                <strong>Mercado Pago</strong> (processamento de pagamentos):{" "}
                                <a
                                    href="https://www.mercadopago.com.br/ajuda/termos-e-politicas_194"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos e Políticas
                                </a>
                            </li>
                            <li>
                                <strong>OneSignal</strong> (notificações push):{" "}
                                <a
                                    href="https://onesignal.com/tos"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Terms of Service
                                </a>
                            </li>
                            <li>
                                <strong>SendPulse</strong> (e-mail / mensagens):{" "}
                                <a
                                    href="https://sendpulse.com/legal/termsofservice"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Terms of Service
                                </a>
                            </li>
                            <li>
                                <strong>OpenStreetMap</strong> (dados de mapas):{" "}
                                <a
                                    href="https://operations.osmfoundation.org/policies/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Políticas
                                </a>
                            </li>
                            <li>
                                <strong>CARTO</strong> (serviços de mapas):{" "}
                                <a
                                    href="https://carto.com/legal"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Legal
                                </a>
                            </li>
                            <li>
                                <strong>Firebase / Google</strong> (infraestrutura e mensageria):{" "}
                                <a
                                    href="https://firebase.google.com/terms"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Terms of Service
                                </a>
                            </li>
                            <li>
                                <strong>Apple App Store</strong> (distribuição do aplicativo iOS):{" "}
                                <a
                                    href="https://www.apple.com/legal/internet-services/itunes/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos de Serviço
                                </a>
                            </li>
                            <li>
                                <strong>Google Play</strong> (distribuição do aplicativo Android):{" "}
                                <a
                                    href="https://play.google.com/about/play-terms/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    Termos de Serviço
                                </a>
                            </li>
                        </ul>
                        <p className="mt-2 text-sm text-gray-600">
                            URLs e versões das políticas de terceiros podem mudar; confira na
                            data de acesso. Para exercer seus direitos relativos aos seus dados
                            pessoais, contate nosso Encarregado de Proteção de Dados (DPO):{" "}
                            <a
                                href="mailto:dpo@trusom.com"
                                className="text-blue-600 underline"
                            >
                                dpo@trusom.com
                            </a>
                            .
                        </p>
                    </div>

                    {/* 15. Contato */}
                    <div>
                        <h2 className="mb-3 text-xl font-semibold">15. Contato</h2>
                        <p>
                            Para dúvidas sobre estes Termos, entre em contato:{" "}
                            <a
                                href="mailto:software@trusom.com"
                                className="text-blue-600 underline"
                            >
                                software@trusom.com
                            </a>
                        </p>
                        <p className="mt-2">
                            Para questões sobre proteção de dados:{" "}
                            <a
                                href="mailto:dpo@trusom.com"
                                className="text-blue-600 underline"
                            >
                                dpo@trusom.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsAndConditionsRider;
